import { DateTime } from "luxon";

import { CustomerNoteType, EnhancedCustomerNote } from "../../../Models/CustomerNote";

/** A data representation of a note assigned to a customer at some point in the past. */
class PreviousCustomerNote {
  /** Timestamp of the note's creation. */
  createdAt: DateTime;
  /** A flag indicating if this note indicates a problem was encountered with the customer.
   * @remarks Red flags are assigned for a variety of reasons, including aggressive behavior at an appointment.
   */
  isRedFlag: boolean;
  /** The content of the note. */
  text: string;
  /** An enum value indicating when the note should be shown to a user of the Zenoti portal.
   * @remarks For example: {@link CustomerNoteType.ShowDuringCheckIn} indicates the note should be shown to the
   * front-desk coordinator when the customer checks in.
   */
  type: CustomerNoteType;

  constructor(previousNote: EnhancedCustomerNote) {
    if (!previousNote.createdAt) throw "A created at timestamp is required.";
    this.createdAt = previousNote.createdAt;
    this.text = previousNote.text;
    this.type = previousNote.type;
    this.isRedFlag = previousNote.isRedFlag;
  }
}

export default PreviousCustomerNote;
